export const customerList = [
    {
        id: 1,
        name: 'Alice Johnson',
        email: 'alicejohnson@example.com',
        country: 'United Kingdom',
        contact: '(+44) 20 7946 0958',
        status: 'Active'
    },
    {
        id: 2,
        name: 'Bob Smith',
        email: 'bobsmith@example.com',
        country: 'United Kingdom',
        contact: '(+44) 20 7946 0958',
        status: 'Inactive'
    },
    {
        id: 3,
        name: 'Charlie Brown',
        email: 'charliebrown@example.com',
        country: 'United Kingdom',
        contact: '(+44) 20 7946 0958',
        status: 'Active'
    },
    {
        id: 4,
        name: 'David Wilson',
        email: 'davidwilson@example.com',
        country: 'United Kingdom',
        contact: '(+61) 3 8652 1456',
        status: 'Active'
    },
    {
        id: 5,
        name: 'Eva Green',
        email: 'evagreen@example.com',
        country: 'United Kingdom',
        contact: '(+49) 30 12345678',
        status: 'Inactive'
    },
    {
        id: 6,
        name: 'Frank Wright',
        email: 'frankwright@example.com',
        country: 'United Kingdom',
        contact: '(+81) 3-1234-5678',
        status: 'Active'
    },
    {
        id: 7,
        name: 'Grace Lee',
        email: 'gracelee@example.com',
        country: 'United Kingdom',
        contact: '(+65) 6778 1234',
        status: 'Inactive'
    },
    {
        id: 8,
        name: 'Henry Adams',
        email: 'henryadams@example.com',
        country: 'United Kingdom',
        contact: '(+91) 22 1234 5678',
        status: 'Active'
    },
    {
        id: 9,
        name: 'Ivy Clark',
        email: 'ivyclark@example.com',
        country: 'United Kingdom',
        contact: '(+33) 1 23 45 67 89',
        status: 'Active'
    },
    {
        id: 10,
        name: 'Jack Martin',
        email: 'jackmartin@example.com',
        country: 'United Kingdom',
        contact: '(+86) 10 1234 5678',
        status: 'Inactive'
    }
]


export const locationData = [
    {
        id: 0,
        name: 'United Kingdom', value: 'united-kingdom'
    },
    {
        id: 1,
        name: 'Europe', value: 'europe'
    },
    {
        id: 2,
        name: 'Rest of the world', value: 'rest-of-world'
    },

]

export const countryData = [
    {
        id: 0,
        name: 'Wales', value: 'wales'
    },
    {
        id: 1,
        name: 'Dubai', value: 'dubai'
    },
    {
        id: 2,
        name: 'China', value: 'china'
    },

]

export const orderHistoryData = [
    { date: "12/01/2021", packingListId: "0012", quality: "RM001 (Navy)", totalAmount: "$1,200.00", status: "Delivered" },
    { date: "12/01/2021", packingListId: "0012", quality: "RM002 (Black)", totalAmount: "$1,500.00", status: "Delivered" },
    { date: "12/01/2021", packingListId: "0012", quality: "RM003 (White)", totalAmount: "$1,800.00", status: "Delivered" },
    { date: "12/01/2021", packingListId: "0012", quality: "RM004 (Red)", totalAmount: "$1,200.00", status: "Shipped" },
    { date: "12/01/2021", packingListId: "0012", quality: "RM005 (Blue)", totalAmount: "$1,500.00", status: "Delivered" },
    { date: "12/01/2021", packingListId: "0012", quality: "RM006 (Green)", totalAmount: "$1,800.00", status: "Delivered" },
    { date: "12/01/2021", packingListId: "0012", quality: "RM007 (Yellow)", totalAmount: "$1,200.00", status: "Delivered" },
    { date: "12/01/2021", packingListId: "0012", quality: "RM008 (Orange)", totalAmount: "$1,500.00", status: "Delivered" },
    { date: "12/01/2021", packingListId: "0012", quality: "RM009 (Purple)", totalAmount: "$1,800.00", status: "Delivered" },
]

export enum LinkedProductPriceType {
  CostPerMetre = 0,
  CostPerYarn = 1
}

export const priceTypeOptions = [
  { label: 'Cost per metre', value: LinkedProductPriceType.CostPerMetre },
  { label: 'Cost per yard', value: LinkedProductPriceType.CostPerYarn }
]